import { useState, useCallback, useLayoutEffect } from 'react';

/**
 * @example const triggerFunction = useTriggerableLayoutEffect(cb);
 * @param cb The callback function that will be invoked after re-render by the useLayoutEffect.
 * @returns triggerFunction:: The function that will trigger the useLayoutEffect.
 */
const useTriggerableLayoutEffect = (cb: (...args: unknown[]) => void) => {
  const [state, setState] = useState<
    { triggered: false; args: null } | { triggered: true; args: any[] }
  >({
    triggered: false,
    args: null
  });

  useLayoutEffect(() => {
    if (!state.triggered) return;

    setState({
      triggered: false,
      args: null
    });

    cb(...state.args);
  }, [cb, state]);

  return useCallback((...args: unknown[]) => {
    setState({ triggered: true, args });
  }, []);
};

export default useTriggerableLayoutEffect;
